export enum ClimateActionVerified {
  Verified,
  Unverified,
}
